import Model from '@/shared/orm/Model'
import i18n from '@/plugins/i18n'

export default class Popup extends Model {
    resourceName() {
        return 'popup-settings'
    }

    fields() {
        return [
            'title',
            'content',
            'slug',
            'latest',
            'persistent',
            'touchable',
            'redirect_to',
            'width',
        ]
    }

    get tableColumns() {
        return [
            {
                text: i18n.t('resources.popupSetting.attributes.slug'),
                value: 'slug',
                sortable: false,
            },
            {
                text: i18n.t('resources.popupSetting.attributes.title'),
                value: 'title',
                sortable: false,
            },
            {
                text: i18n.t('tables.actions'),
                value: 'action',
                sortable: false,
                align: 'end',
            },
        ]
    }

    get actions() {
        return [
            {
                type: 'edit',
                to: {
                    name: 'popup.edit',
                    params: { id: this.id },
                },
            },
            {
                type: 'delete',
            },
        ]
    }
}
